/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteStatusRequest interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteStatusRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('EmailInviteToken' in value) || value['EmailInviteToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'Game': json['Game'],
        'EmailInviteToken': json['EmailInviteToken'],
    };
}
export function FxIdWebFeaturesInviteEmailInviteStatusRequestToJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteStatusRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteStatusRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'Game': value['Game'],
        'EmailInviteToken': value['EmailInviteToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInviteEmailInviteStatusRequest.js.map